import { render, staticRenderFns } from "./infoCost.vue?vue&type=template&id=378bbe4d&scoped=true&"
import script from "./infoCost.vue?vue&type=script&lang=js&"
export * from "./infoCost.vue?vue&type=script&lang=js&"
import style0 from "./infoCost.vue?vue&type=style&index=0&id=378bbe4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378bbe4d",
  null
  
)

export default component.exports